.report-actions {
  display: flex;
  flex-direction: row;
  > button {
    min-width: 108px;
    margin-right: 10px;
  }
}
